import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { getWhatsAppUrl } from "./WhatsAppButton";
import { Logo } from "./Logo";

const navItems = [
  { label: "Services", href: "#services" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Why Us", href: "#why-us" },
  { label: "Contact", href: "#contact-form" },
];

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 py-6">
      <div className="container">
        <div className="flex flex-col items-center gap-4">
          {/* Logo - Centered */}
          <a href="#" className="flex items-center" aria-label="The Corporate Car Wash Company home">
            <Logo variant="light" />
          </a>

          {/* Desktop Navigation - Centered */}
          <nav className="hidden lg:flex items-center gap-10">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => scrollToSection(item.href)}
                className="text-sm font-medium tracking-wide uppercase transition-colors duration-300 hover:text-accent text-primary-foreground/80 py-2"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden absolute right-6 top-6 p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-primary-foreground" />
            ) : (
              <Menu className="h-6 w-6 text-primary-foreground" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-background border-t border-border mt-4 py-6 shadow-lg -mx-6 px-6">
            <nav className="flex flex-col gap-2">
              {navItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => scrollToSection(item.href)}
                  className="text-left py-3 text-foreground font-medium text-lg hover:text-accent transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <div className="pt-6 flex flex-col gap-3 border-t border-border mt-4">
                <Button variant="cta" size="lg" onClick={() => scrollToSection("#contact-form")}>
                  Get a Quote
                </Button>
                <Button variant="whatsapp" size="lg" asChild>
                  <a href={getWhatsAppUrl()} target="_blank" rel="noopener">
                    WhatsApp Us
                  </a>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
